import api from './api';

export interface SoDuDto {
  maChamCong: string;
  nghiBuGoc: number | null;
  nghiPhepGoc: number | null;
  tenNV: string;
}

export interface DieuChinhSoDuRequest {
  maChamCongNhanVien: string;
  loaiNgay: 'NghiBu' | 'NghiPhep';
  soNgay: number;
  lyDo: string;
}

export const dieuChinhSoDuService = {
  getSoDu: async (maChamCong: string): Promise<SoDuDto> => {
    const response = await api.get(`/DieuChinhSoDu/sodu/${maChamCong}`);
    return response.data;
  },

  capNhatSoDu: async (request: DieuChinhSoDuRequest): Promise<void> => {
    await api.post('/DieuChinhSoDu/capnhat', request);
  },
};